import { connect } from 'react-redux'
import AssessmentsTable from './assessments-table'
import { getAssessmentsList } from '../../../../../stores/assessment/assessment.selectors'

const mapStateToProps = state => {
  const assessments = getAssessmentsList(state)
  return {
    assessments: assessments,
    noAssessments: !assessments.length
  }
}

export default connect(
  mapStateToProps,
  null
)(AssessmentsTable)
